<template>
  <div class="content">

    <SearchNavBar
      v-model:value="keywords"
      @onSearch="onNavSearch"
    />
    <div class="page-content">
      <!-- 轮播图 -->
      <Swipe :data="bannerList" />
      <!-- 导航区 -->
      <Navigation :data="goodsCategoryList" />
      <!-- 标题 -->
      <HeaderTitle
        title="热卖爆款"
        :icon="hotIcon"
      >
        <template #right>
          <span>大众心理，测试爆品</span>
        </template>
      </HeaderTitle>
      <!-- 卡片列表 -->
      <CardList
        :data="hotList"
        @clickItem="handleGoodsItem"
      />

      <ShadowButton @click="handleToggleHotList">
        换一批
      </ShadowButton>

      <HeaderTitle
        title="新品首发"
        :icon="newIcon"
      >
        <template #right>
          <span>一天一测，保持快乐</span>
        </template>
      </HeaderTitle>
      <!--新品首发列表 -->
      <CellList
        :data="newList"
        @clickItem="handleGoodsItem"
      />
      <HeaderTitle
        plain
        title="精选推荐"
      >
        <template #right>
          <span
            @click="handleAll"
            class="pointer"
          >查看全部内容</span>
        </template>
      </HeaderTitle>
      <!-- 推荐商品列表 -->
      <CellCardList
        :data="tuiList"
        @clickItem="handleGoodsItem"
      />
      <ShadowButton @click="handleAll">
        查看全部
      </ShadowButton>

      <CopyRight />

    </div>
  </div>
</template>

<script>
import { reactive, toRefs, onMounted } from "vue";
import { useRouter } from "vue-router";
import SearchNavBar from "@/components/SearchNavBar";
import CellCardList from "@/components/CellCardList";
import HeaderTitle from "@/components/HeaderTitle";
import CopyRight from "@/components/CopyRight";
import Swipe from "./components/Swipe";
import Navigation from "./components/Navigation";

import CardList from "./components/CardList";
import ShadowButton from "./components/ShadowButton";
import CellList from "./components/CellList";

import { getHomeData, getIndexGoods } from "@/api/home";
import hotIcon from "@/assets/images/hot.png";
import newIcon from "@/assets/images/new.png";
import { loadingToast } from "@/plugins/vant";

import { useWx } from "@/hooks/useWx";

export default {
  name: "home",
  components: {
    SearchNavBar,
    Swipe,
    Navigation,
    HeaderTitle,
    CardList,
    ShadowButton,
    CellList,
    CellCardList,
    CopyRight,

  },
  setup() {
    const router = useRouter();
    const state = reactive({
      keywords: "", //搜索输入框值
      bannerList: [], //轮播图数据
      goodsCategoryList: [], //分类数据
      hotList: [], //热卖爆款
      newList: [], //新品首发
      tuiList: [], //推荐商品
      query: {
        page: 1,
        limit: 4,
        type: 1,
      },
      maxPage: 1,
    });
    onMounted(() => {
      init();
      useWx({ type: 1 });
    });

    // 跳转搜索页
    function onNavSearch() {
      router.push({
        path: "/search",
        query: {
          keywords: state.keywords,
        },
      });
    }
    // 初始化首页数据
    async function init() {
      try {
        const {
          data: { bannerList, goodsCategoryList, goodsList },
        } = await getHomeData();
        state.bannerList = bannerList;
        state.goodsCategoryList = goodsCategoryList;
        state.hotList = goodsList.hot.data;
        state.newList = goodsList.new.data;
        state.tuiList = goodsList.tui.data;
      } catch (error) {
        console.log(error);
      }
    }
    // 换一批
    async function handleToggleHotList() {
      try {
        if (state.query.page >= state.maxPage && state.query.page !== 1) {
          state.query.page = 0;
        }
        state.query.page++;
        const loading = loadingToast();
        const { data } = await getIndexGoods(state.query);
        loading.clear();
        state.hotList = data.data;
        const maxPage = data.total / state.query.limit;
        state.maxPage = Math.floor(maxPage);
      } catch (error) {
        console.log(error);
      }
    }
    // 查看全部内容
    function handleAll() {
      router.push("/category");
    }
    // 商品点击
    function handleGoodsItem({ guid }) {
      router.push({
        path: "/goods",
        query: {
          guid,
        },
      });
    }

    return {
      handleAll,
      handleGoodsItem,
      handleToggleHotList,
      onNavSearch,
      ...toRefs(state),
      hotIcon,
      newIcon,
    };
  },
};
</script>

<style lang="less" scoped>
.page-content {
  padding: @padding-sm @padding-base 0 @padding-base;
}
</style>